import Vue from "vue";
import Router from "vue-router";
import Layout from "@/views/Layout";
Vue.use(Router);

export default new Router({
	routes: [
		{
			path: "/",
			name: "home",
			component: () => import("./views/Home.vue"),
			meta: {
				title: "王勇博的博客",
				content: {
					keywords: "王勇博，王勇博的博客",
					description: "王勇博的博客，记录我的生活",
				},
			},
		},
		{
			path: "/about",
			component: Layout,
			children: [
				{
					path: "",
					name: "about-content",
					component: () => import("./views/About.vue"),
					meta: {
						title: "关于我",
					},
				},
			],
		},
		{
			path: "/article",
			component: Layout,
			children: [
				{
					path: "",
					name: "article-index",
					component: () => import("./views/Article.vue"),
					meta: {
						title: "生活笔记",
					},
				},
				{
					path: "/article/:id",
					name: "article-content",
					component: () => import("./views/Content.vue"),
				},
			],
		},
		{
			path: "/study",
			component: Layout,
			children: [
				{
					path: "",
					name: "study-index",
					component: () => import("./views/Study.vue"),
					meta: {
						title: "技术笔记",
					},
				},
				{
					path: "/study/:id",
					name: "study-content",
					component: () => import("./views/Content.vue"),
				},
			],
		},
		{
			path: "/algorithm",
			component: Layout,
			children: [
				{
					path: "",
					name: "algorithm-index",
					component: () => import("./views/Algorithm.vue"),
					meta: {
						title: "算法练习",
					},
				},
				{
					path: "/algorithm/:id",
					name: "algorithm-detail",
					component: () => import("./views/Content.vue"),
				},
			],
		},
		{
			path: "/presentation",
			component: Layout,
			children: [
				{
					path: "",
					name: "presentation-content",
					component: () => import("./views/Presentation.vue"),
					meta: {
						title: "工具收藏",
					},
				},
			],
		},
		{
			path: "/note",
			component: Layout,
			children: [
				{
					path: "",
					name: "note-index",
					component: () => import("./views/Note.vue"),
					meta: {
						title: "文章收藏",
					},
				},
				{
					path: "/note/:id",
					name: "note-content",
					component: () => import("./views/Content.vue"),
				},
			],
		},
		{
			path: "/friend",
			component: Layout,
			children: [
				{
					path: "",
					name: "friend-content",
					component: () => import("./views/Friend.vue"),
					meta: {
						title: "友情链接",
					},
				},
			],
		},
		{
			path: "/item50",
			component: Layout,
			children: [
				{
					path: "",
					name: "item50-index",
					component: () => import("./views/Item50.vue"),
					meta: {
						title: "50个项目",
					},
				},
			],
		},
		{
			path: "/myitem",
			component: Layout,
			children: [
				{
					path: "",
					name: "myitem-index",
					component: () => import("./views/Myitem.vue"),
					meta: {
						title: "我的项目",
					},
				},
			],
		},
		{
			path: "/messages",
			component: Layout,
			children: [
				{
					path: "",
					name: "messages-index",
					component: () => import("./views/Messages.vue"),
					meta: {
						title: "留言板",
					},
				},
			],
		},
	],
});
